import { render, staticRenderFns } from "./BajaEstablecimiento.vue?vue&type=template&id=26ec2d3a&"
import script from "./BajaEstablecimiento.vue?vue&type=script&lang=ts&"
export * from "./BajaEstablecimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports